import { Users } from 'lucide-react';
import Card from '../ui/Card';
import Avatar from '../ui/Avatar';
import type { GroupChat } from '../NetworkingView';
import './GroupCard.css';

export type GroupCardProps = {
    group: GroupChat;
    onOpen: (group: GroupChat) => void;
};

function GroupCard({ group, onOpen }: GroupCardProps) {
    const unread = group.unreadCount ?? 0;
    return (
        <Card
            variant="row"
            interactive
            className="group-card"
            onClick={() => onOpen(group)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onOpen(group);
                }
            }}
            aria-label={`Open ${group.name} group chat`}
        >
            <Card.Header>
                <Avatar name={group.name} icon={<Users size={20} />} size="md" />
                <div className="group-card__identity">
                    <div className="group-card__title-row">
                        <h3 className="group-card__name">{group.name}</h3>
                        {group.lastMessageTime && (
                            <span className="group-card__time">{group.lastMessageTime}</span>
                        )}
                    </div>
                    <p className="group-card__members">{group.members.length} members</p>
                    {group.lastMessage && (
                        <p className="group-card__last-message">{group.lastMessage}</p>
                    )}
                </div>
                {unread > 0 && <span className="ui-badge">{unread}</span>}
            </Card.Header>
        </Card>
    );
}

export default GroupCard;
